export default __webpack_public_path__ + "static/media/python.89345dee.png";